import React from 'react';
import Icon from "components/elements/Icon";
import { IFeature } from "components/pricing/Features/Features";
import { IPricingPlan } from "components/pricing/Plan";
import ReactTooltip from "react-tooltip";

type Props = {
    features: IFeature[],
    plans: IPricingPlan[],
    planHasFeature: (plan: string, feature: IFeature) => boolean;
};

export default function DesktopFeatures(props: Props) {
    const { features, plans, planHasFeature } = props;
    return (
        <div>
            {features.map((feature) => {
                const isLastChild = features[features.length - 1] == feature;
                return (
                    <div className={`lg:flex hidden`} key={feature.id}>
                            <span
                                className={`font-normal text-sm self-center flex text-gray-500 pl-2 ${isLastChild ? 'pb-10' : ''}`}
                            >
                                {feature.name}
                                <div
                                    className={"bg-primary-100 w-4 h-4 rounded-full self-center ml-2 flex justify-center"}
                                    data-tip=""
                                    data-for={feature.id}
                                >
                                    <Icon
                                        url={"/static/icons/question-mark-round.svg"}
                                        className={`bg-white h-4 w-4 flex self-center`}
                                    />
                                    <ReactTooltip
                                        id={feature.id}
                                        effect={'solid'}
                                        place={'right'}
                                        type={'light'}
                                        aria-haspopup='true'
                                        className={"bg-white rounded-xl p-4 shadow"}
                                    >
                                        <p className={"text-sm"}>{feature.tooltip}</p>
                                    </ReactTooltip>
                                </div>
                            </span>
                        <div className={"flex flex-1 justify-end"}>
                            {plans.map((plan) => {
                                const isMostPopular = plan.mostPopular == true;
                                const planValue = feature.planValue.find((pv) => pv.plan.name == plan.name);
                                return (
                                    <div
                                        className={`py-4 flex justify-center 2xl:w-72 lg:w-64 px-1  ${isMostPopular ? 'bg-primary-25 ' : ''} ${isLastChild ? 'pb-10' : ''}`}
                                        key={plan.id}
                                    >
                                        {planValue ? (
                                            <div className={'text-sm text-gray-500'}>
                                                {planValue.value}
                                            </div>
                                        ) : (
                                            <>
                                                {planHasFeature(plan.name, feature) ? (
                                                    <Icon
                                                        url={"/static/icons/checkmark.svg"}
                                                        className={`bg-primary-400 h-4 w-4`}
                                                    />
                                                ) : (
                                                    <Icon
                                                        url={"/static/icons/close.svg"}
                                                        className={`bg-purple-dark h-3 w-3 opacity-20`}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}